<template>
  <a-table
    class="resourceTable custom-table scroll-hidden-table"
    :row-key="record => `${record.name}-${record.monitor_address}`"
    :columns="columns"
    :data-source="dataSource"
    :scroll="{ x: scrollX }"
    :pagination="{ pageSize: 5, total: dataSource.length, showTotal: v => `共 ${v} 条` }"
  >
      <template #indicatorsTitle>
        <a-space v-if="itemList && itemList.length">
          <span>指标</span>
          <a-tooltip>
            <template slot="title">
              <div v-for="indicator in itemList" :key="indicator.id">
                <span>{{ `${indicator.name}: 【${$t('calculation_method.' + indicator.method)}】[${indicator.value_range}]` }}</span>
              </div>
            </template>

            <a-icon
              type="question-circle"
              style="color: rgba(0, 0, 0, 0.45)"
            ></a-icon>
          </a-tooltip>
        </a-space>
        <span v-else>指标</span>
      </template>

    <template slot="state" slot-scope="text">
      <score-tag :state="text"></score-tag>
    </template>

    <template slot="name" slot-scope="record">
      <a-tooltip placement="topLeft" :title="record">{{ record }}</a-tooltip>
    </template>

    <template slot="indicators" slot-scope="record, row">
      <div style="max-height: 300px; overflow: auto">
        <div
          class="indicatorsContainer"
          v-for="(item, index) in record.filter(v => v.state === row.state)"
          :key="`${item.key}-${index}-1`"
        >
          <div style="display: flex; align-items: center; min-width: 220px">
            <a-tooltip :title="`${item.name || '-'}：${item.value}%`">
              <div style="display: flex; align-items: center; flex:1">
                <score-tag v-if="item.state" class="inline-score-tag" :state="item.state"></score-tag>
                <div class="text-overflow-multiline">{{ item.name }}</div>
              </div>
            </a-tooltip>
            <div style="margin: 0 6px; width: 60px; text-align: center; font-weight: 500">{{ item.value }}%</div>
          </div>
          <a-tooltip :title="item.description || '-'">
            <div class="indicator-description text-overflow-multiline">{{ item.description || '-' }}</div>
          </a-tooltip>
        </div>

        <div
          class="indicatorsContainer"
          v-for="(item, index) in record.filter(v => v.state !== row.state)"
          :key="`${item.key}-${index}-2`"
        >
          <div style="display: flex; align-items: center; min-width: 220px">
            <a-tooltip :title="`${item.name || '-'}：${item.value}`">
              <div style="display: flex; align-items: center; flex:1">
                <score-tag v-if="item.state" class="inline-score-tag" :state="item.state"></score-tag>
                <div class="text-overflow-multiline">{{ item.name }}</div>
              </div>
            </a-tooltip>
            <div style="margin: 0 6px; width: 60px; text-align: center; font-weight: 500">{{ item.value }}%</div>
          </div>
          <a-tooltip :title="item.description || '-'">
            <div class="indicator-description text-overflow-multiline">{{ item.description || '-' }}</div>
          </a-tooltip>
        </div>
      </div>
    </template>
  </a-table>
</template>

<script>
import ScoreTag from '@/components/tag/ScoreTag.vue'

export default {
  name: 'ResourceTable',
  props: {
    dataSource: {
      type: Array
    },
    itemList: {
      type: Array
    }
  },
  components: {
    ScoreTag
  },
  data () {
    return {
      columns: [
        {
          dataIndex: 'state',
          title: '繁忙度',
          width: 100,
          scopedSlots: {
            customRender: 'state'
          }
        },
        {
          dataIndex: 'name',
          title: '名称',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'monitor_address',
          title: 'IP 地址',
          width: 180,
          scopedSlots: {
            customRender: 'monitorAddress'
          }
        },
        {
          dataIndex: 'indicators',
          width: 320,
          scopedSlots: {
            customRender: 'indicators'
          },
          slots: { title: 'indicatorsTitle' }
        }
      ]
    }
  },
  computed: {
    scrollX () {
      let sum = 0
      this.columns.forEach(column => {
        sum += column.width
      })
      return sum
    }
  }
}
</script>

<style lang="less" scoped>
.resourceTable {
  .indicatorsContainer {
    display: flex;
    font-size: 13px;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0 0 8px 0;
    padding: 0 16px 6px 4px;
    border-bottom: 1px solid #e8ecf3;

    &:last-of-type {
      border: none;
    }

    .inline-score-tag{
      margin: 0 6px;
      :deep(.ant-tag) {
        width: 37px !important;
        font-size: 11px;
        height: 22px;
        max-height: 22px;
      }
    }

    .indicator-description {
      color: rgba(0, 0, 0, .55);
      font-size: 12px;
    }
  }
}
</style>
